module.exports = __webpack_public_path__ + "img/reserveSession.9a3f21b1.svg";